/* eslint-disable */
import { getAccessToken } from '../store/global'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { getConfig } from '@/common/utils/appConfig'
import { isR4 } from '@/features/transaction-signing/constants'

export function postRequest(body, options) {
	if (body) {
		options.body = JSON.stringify(body, (key, value) => {
			if (value === undefined) {
				return ''
			}
			return value
		})
	}
}

export function getRequest(body) {
	let param = ''
	if (body) {
		Object.keys(body).forEach((key, index) => {
			param = `${param + key}=${body[key]}`
			if (index !== Object.keys(body).length - 1) {
				param = `${param}&`
			}
		})
	}
	return param
}

export function fetchRequest(endpoint, method, body, headerOptions, needHeader = true, isSubmitValidate = false) {
	const options = {
		method,
		headers: needHeader ? buildRequestHeader(headerOptions, null) : {},
		body
	}

	switch (method) {
		case 'POST':
			postRequest(body, options)
			//if (body) {
			//  options.body = JSON.stringify(body, (key, value) => {
			//    if (value === undefined) {
			//      return "";
			//    }
			//    return value;
			//  });
			//}
			break
		case 'GET': {
			let param = ''
			param = getRequest(body)
			//if (body) {
			//  Object.keys(body).forEach((key, index) => {
			//    param = `${param + key}=${body[key]}`;
			//    if (index !== Object.keys(body).length - 1) {
			//      param = `${param}&`;
			//    }
			//  });
			//}
			if (param !== '') {
				endpoint = `${endpoint}?${param}`
			}
			options.body = undefined
			break
		}
		default:
			break
	}

	console.log('fetchRequest, header:')
	console.log(JSON.stringify(options.header))
	console.dir(options.header)

	return fetch(endpoint, options)
		.then(checkStatus)
		.then(parseJSON)
		.then(statusCodeUpperCase)
		.catch(err => {
			console.log('fetch-----', err)
			if (err === 401 && !isSubmitValidate) {
				const action = {
					routeType: 'tokenExpired'
				}
				window.parent.postMessage(action, window.location.origin)
				throw new Error('401')
			} else if (err === 401) {
				throw new Error('401-unassign')
			} else {
				throw new Error(JSON.stringify(err))
			}
		})
}

export function fetchRequestWithBodyHeader(endpoint, method, body, headerOptions, removexAccOpIfAvailable) {
	const options = {
		method,
		headers: buildRequestHeader(headerOptions, removexAccOpIfAvailable),
		body
	}

	switch (method) {
		case 'POST':
			if (body) {
				options.body = JSON.stringify(body)
			}
			break
		case 'GET': {
			let param = ''
			if (body) {
				Object.keys(body).forEach((key, index) => {
					param = `${param + key}=${body[key]}`
					if (index !== Object.keys(body).length - 1) {
						param = `${param}&`
					}
				})
			}
			if (param !== '') {
				endpoint = `${endpoint}?${param}`
			}
			break
		}
		default:
			break
	}
	return (
		fetch(endpoint, options)
			.then(checkStatus)
			.then(res =>
				res.json().then(_body => ({
					headers: {
						'x-acc-op': res.headers.get('x-acc-op'),
						'x-ref-op': res.headers.get('x-ref-op')
					},
					status: res.status,
					body
				}))
			)
			//.then(statusCodeUpperCase)
			.catch(err => {
				console.log('fetch-----', err)
				if (err === 401) {
					const action = {
						routeType: 'tokenExpired'
					}
					window.parent.postMessage(action, window.location.origin)
				}
				throw err
				// throw new Error(JSON.stringify(err));
			})
	)
}

function statusCodeUpperCase(resp) {
	if (resp.status) {
		// This handling is actually meant for ms-accounts, for that they are not standardize the uppercase
		resp.status = resp.status.toUpperCase()
	}
	return resp
}

function checkStatus(resp) {
	if (resp.status === 401) {
		//const action = {
		//	routeType: 'tokenExpired'
		//}
		//window.parent.postMessage(action, window.location.origin)
		throw resp.status
	}
	//const error = new Error(resp.statusText);
	// if (resp.status >= 200 && resp.status < 500) {
	//   if (resp.status === 404) {
	//     error.response = resp;
	//     throw error;
	//   }
	// if (resp.status === 200 || resp.status === 400) {
	return resp
	// }
	// if time out need to nofity inb to time out.
	// const { requestINBTimeout } = getConfig();
	// if (resp.status === 401 && requestINBTimeout) {
	//   requestINBTimeout();
	// }
	//error = new Error(resp._bodyText ? resp._bodyText : resp.statusText);
	//error.response = resp;

	//throw error;
}

function parseJSON(resp) {
	return resp.json()
}

function parseHTML(resp) {
	return resp.text()
}

function buildRequestHeader(
	headerOptions,
	removexAccOpIfAvailable, //remove this from header if your endpoint doesn't need it. detault to false
) {
	let header = {}
	if (headerOptions !== undefined && headerOptions !== null) {
		header = { ...headerOptions }
	}
	// add your own headers here
	header['Accept'] = 'application/json'
	header['Content-Type'] = 'application/json'
	header['x-source-id'] = 'DTB'
	header['x-correlation-id'] = uuidv4()
	header['x-unique-session-id'] = window.sessionStorage.getItem('userUniqueSessionId')
	header['x-source-country'] = getConfig().country
	header['x-source-date-time'] = moment(new Date()).format('YYYY-MM-DD HH:mm:ss.SSS')
	header['x-business-type'] = 'Corporate'

	const xAccOp = isR4 ? window.sessionStorage.getItem('x_acc_op') : getAccessToken()
	if (!removexAccOpIfAvailable && xAccOp) {
		header['x-acc-op'] = xAccOp
	}
	console.log('header:')
	console.log(JSON.stringify(header))
	console.dir(header)
	return header
}
